import { Box, Card, Flex, Heading, Stack } from "@chakra-ui/react";
import React from "react";
import BackButton from "../components/BackButton";

const NotfoundPage = () => {
  return (
    <Flex direction="column" h="100vh" maxW="md" mx="auto" p={4}>
      <Card p={4} h="calc(100vh - 32px)">
        <BackButton />
        <Box display="flex" justifyContent="center" alignItems="center">
          <Stack spacing={4} mt="50px" textAlign="center">
            <Heading>404</Heading>
            <div>This page is not available!</div>
          </Stack>
        </Box>
      </Card>
    </Flex>
  );
};
export default NotfoundPage;
